export default __webpack_public_path__ + "static/media/icon-download-primary.7c7af9e6.svg";